// components/SponsorAddForm.js
import { useState, useContext } from "react";
import { addDoc, collection } from "firebase/firestore";
import { db, storage} from "../../../firebase";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { useParams } from "react-router-dom"; 
import { TextField, Button, Stack } from "@mui/material";
import { EventContext } from "../../../pages/Dashboard";
import { v4 as uuidv4 } from "uuid";import {
    LinearProgress,
    Typography,
  } from "@mui/material";

const SponsorAddForm = ({ onSponsorAdded, onClose }) => {
  const [sponsorName, setSponsorName] = useState("");
  const [logoFile, setLogoFile] = useState(null);

  const {eventID} = useParams();
  const [uploading, setUploading] = useState(false);

  const handleUpload = async () => {
    if (!logoFile || !eventID) return null;

    const fileRef = ref(
      storage,
      `sponsors/${eventID}/${uuidv4()}_${logoFile.name}`
    );

    const snap = await uploadBytes(fileRef, logoFile);
    const url = await getDownloadURL(snap.ref);
    return url;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!sponsorName || !logoFile || !eventID) return;

    setUploading(true);
    try {
      const logoURL = await handleUpload();

      await addDoc(collection(db, "events", eventID, "sponsors"), {
        sponsorName,
        sponsorLogo: logoURL,
      });

      if (onSponsorAdded) onSponsorAdded();
      if (onClose) onClose();
    } catch (err) {
      console.error("Error adding sponsor:", err.message);
    } finally {
      setUploading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Stack spacing={2} sx={{ mt: 1 }}>
        <TextField
          label="Sponsor Name"
          value={sponsorName}
          onChange={(e) => setSponsorName(e.target.value)}
          required
        />
        <input
          type="file"
          accept="image/*"
          onChange={(e) => setLogoFile(e.target.files[0])}
          required
        />
        {uploading && <LinearProgress />}
        <Button type="submit" variant="contained" disabled={uploading}>
          {uploading ? "Uploading..." : "Add Sponsor"}
        </Button>
      </Stack>
    </form>
  );
};

export default SponsorAddForm;
